import React, { Component } from 'react'
import classNames from 'classnames';
import ScreenLoaderContainer from '../../../portal/controls/screenLoaderContainer';
import styles from './style.scss';

export default class GroupEntriesLoader extends Component {

    render() {

        return (
            <div className={classNames(styles.gruopEntriesLoaderWrapper)}>
                <ScreenLoaderContainer />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/teams/addLdapGroupMappingList/groupEntriesLoader/index.jsx